import { createContext, useContext } from "react";
/* istanbul ignore next: no logic in this factory! */

/**
 * Create context relevant objects to use within React.
 *
 * @param object
 * @returns
 */

function createContextFactory(object) {
  /**
   * MobX stores collection
   */
  const StoreContext = /*#__PURE__*/createContext(object);
  /**
   * MobX HOC to get the context via hook.
   *
   * @param children
   */

  const StoreProvider = ({
    children
  }) => /*#__PURE__*/React.createElement(StoreContext.Provider, {
    value: object
  }, children);
  /**
   * Get all the MobX stores via a single hook.
   */


  const useStores = () => useContext(StoreContext);

  return {
    StoreContext,
    StoreProvider,
    useStores
  };
}

export { createContextFactory };